"use strict";

function _interopRequireDefault(o) {
  return o && o.__esModule ? o : {
    default: o
  };
}
function _objectWithoutProperties(o, e) {
  var r = {};
  for (var t in o) e.indexOf(t) >= 0 || Object.prototype.hasOwnProperty.call(o, t) && (r[t] = o[t]);
  return r;
}
function make(o, e) {
  var r = e.left,
    t = e.right,
    p = e.up,
    l = e.down,
    a = e.top,
    u = e.bottom,
    i = e.big,
    n = e.mirror,
    s = e.opposite,
    d = (r ? 1 : 0) | (t ? 2 : 0) | (a || l ? 4 : 0) | (u || p ? 8 : 0) | (n ? 16 : 0) | (s ? 32 : 0) | (o ? 64 : 0) | (i ? 128 : 0);
  if (lookup.hasOwnProperty(d)) return lookup[d];
  if (!n != !(o && s)) {
    var _ = [t, r, u, a, l, p];
    r = _[0], t = _[1], a = _[2], u = _[3], p = _[4], l = _[5];
  }
  var y = i ? "2000px" : "100%",
    b = r ? "-" + y : t ? y : "0",
    f = l || a ? "-" + y : p || u ? y : "0";
  return lookup[d] = (0, _globals.animation)("\n    " + (o ? "to" : "from") + " {opacity: 0;transform: translate3d(" + b + ", " + f + ", 0) rotate3d(0, 0, 1, -120deg);}\n\t  " + (o ? "from" : "to") + " {opacity: 1;transform: none}\n  "), lookup[d];
}
function Roll() {
  var o = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : _globals.defaults,
    e = o.children,
    r = (o.out, o.forever),
    t = o.timeout,
    p = o.duration,
    l = void 0 === p ? _globals.defaults.duration : p,
    a = o.delay,
    u = void 0 === a ? _globals.defaults.delay : a,
    i = o.count,
    n = void 0 === i ? _globals.defaults.count : i,
    s = _objectWithoutProperties(o, ["children", "out", "forever", "timeout", "duration", "delay", "count"]),
    d = {
      make: make,
      duration: void 0 === t ? l : t,
      delay: u,
      forever: r,
      count: n,
      style: {
        animationFillMode: "both"
      }
    };
  return (0, _wrap2.default)(s, d, d, e);
}
Object.defineProperty(exports, "__esModule", {
  value: !0
});
var _wrap = require("./wrap"),
  _wrap2 = _interopRequireDefault(_wrap),
  _propTypes = require("prop-types"),
  _globals = require("./globals"),
  propTypes = {
    out: _propTypes.bool,
    left: _propTypes.bool,
    right: _propTypes.bool,
    top: _propTypes.bool,
    bottom: _propTypes.bool,
    big: _propTypes.bool,
    mirror: _propTypes.bool,
    opposite: _propTypes.bool,
    duration: _propTypes.number,
    timeout: _propTypes.number,
    delay: _propTypes.number,
    count: _propTypes.number,
    forever: _propTypes.bool
  },
  lookup = {};
Roll.propTypes = propTypes, exports.default = Roll, module.exports = exports.default;